import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'

// Move the same controls between inline and fixed positions so selected sizes,
// pending requests and keyboard focus never live in duplicate buttons.
const MobilePurchaseBar = ({ children }) => {
  const slotRef = useRef(null)
  const controlsRef = useRef(null)
  const [isFixed, setIsFixed] = useState(false)
  const [height, setHeight] = useState(0)

  useEffect(() => {
    if (!window.IntersectionObserver) return undefined
    const measure = () => setHeight(controlsRef.current?.offsetHeight || 0)
    measure()
    const resizeObserver = window.ResizeObserver
      ? new window.ResizeObserver(measure)
      : null
    resizeObserver?.observe(controlsRef.current)
    window.addEventListener('resize', measure)
    const observer = new window.IntersectionObserver(([entry]) => {
      setIsFixed(!entry.isIntersecting)
    })
    observer.observe(slotRef.current)
    return () => {
      observer.disconnect()
      resizeObserver?.disconnect()
      window.removeEventListener('resize', measure)
    }
  }, [])

  return (
    <div
      ref={slotRef}
      className="pdp-mobile-purchase-slot"
      style={height ? { minHeight: height } : undefined}
    >
      <div
        ref={controlsRef}
        className={`pdp-mobile-purchase-bar${isFixed ? ' is-fixed' : ''}`}
      >
        {children}
      </div>
    </div>
  )
}

MobilePurchaseBar.propTypes = {
  children: PropTypes.node.isRequired,
}

export default MobilePurchaseBar
